import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  themeMode: localStorage.getItem("themeMode") ?? "light",
};

export const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    changeTheme: (state, mode) => {
      state.themeMode = mode.payload;
      localStorage.setItem("themeMode", mode.payload);
    },
  },
});

// Action creators are generated for each case reducer function
export const { changeTheme } = themeSlice.actions;

export default themeSlice.reducer;
